// export main component
import { PeopleMenu } from './components/PeopleMenu';
export default PeopleMenu;

// types
export type { PeopleMenuProps } from './types';
